export const doughnutPolarData = {
  labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo"],
  datasets: [
    {
      data: [120, 190, 300, 250, 400],
      backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"],
    },
  ],
};

export const radarData = {
  labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo"],
  datasets: [
    {
      label: "Ventas",
      data: [120, 190, 300, 250, 400],
      backgroundColor: "rgba(54, 162, 235, 0.2)",
      borderColor: "rgba(54, 162, 235, 1)",
      borderWidth: 2,
    },
    {
      label: "Ventas",
      data: [112, 129, 330, 425, 540],
      backgroundColor: "rgba(84, 235, 54, 0.2)",
      borderColor: "rgb(69, 235, 54)",
      borderWidth: 2,
    },
  ],
};

export const bubbleData = {
  datasets: [
    {
      label: "Ventas",
      backgroundColor: "rgba(54, 162, 235, 0.7)",
      data: [
        { x: 10, y: 120, r: 10 },
        { x: 20, y: 190, r: 15 },
        { x: 30, y: 300, r: 20 },
        { x: 40, y: 250, r: 18 },
        { x: 50, y: 400, r: 25 },
      ],
    },
    {
      label: "Compras",
      backgroundColor: "rgba(235, 178, 54, 0.7)",
      data: [
        { x: 10, y: 20, r: 10 },
        { x: 20, y: 90, r: 15 },
        { x: 30, y: 100, r: 20 },
        { x: 40, y: 50, r: 18 },
        { x: 50, y: 30, r: 25 },
      ],
    },
  ],
};

export const scatterData = {
  datasets: [
    {
      label: "Ventas",
      backgroundColor: "rgba(54, 162, 235, 1)",
      data: [
        { x: 1, y: 120 },
        { x: 2, y: 190 },
        { x: 3, y: 300 },
        { x: 4, y: 250 },
        { x: 5, y: 400 },
      ],
    },
    {
      label: "Compras",
      backgroundColor: "rgb(235, 54, 181)",
      data: [
        { x: 1, y: 541 },
        { x: 2, y: 431 },
        { x: 3, y: 133 },
        { x: 4, y: 222 },
        { x: 5, y: 214 },
      ],
    },
  ],
};
